import TrackElements from '@capsule/track-elements'
import type { TrackingEntry } from 'front/shared/assets/types/TrackingEntry'

export default class ArticlePushMarketing {
	ArticlePushMarketing: HTMLElement | null
	campaignTitle: string

	constructor() {
		this.ArticlePushMarketing = document.querySelector('.articlePushMarketing')
		this.campaignTitle = this.ArticlePushMarketing?.getAttribute('data-campaignTitle') ?? ''
	}

	init() {
		if (this.ArticlePushMarketing && this.campaignTitle) {
			this.initTracking()
		}
	}

	initTracking() {
		const trackElements = new TrackElements(this.trackingEntries)
		trackElements.init()
	}

	get trackingEntries(): TrackingEntry[] {
		return [
			{
				element: this.ArticlePushMarketing,
				display: {
					event: 'navigation_display',
					navigation_type: 'marketing-insert',
					navigation_label: this.campaignTitle
				},
				click: {
					event: 'navigation_click',
					navigation_type: 'marketing-insert',
					navigation_label: this.campaignTitle
				}
			}
		]
	}
}
